import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
@Component({
  template: `
    <ion-list *ngFor="let dropdownItem of aDropdownItem; let i = index">
      <button ion-item (click)="updateOrderType(i)" class="filterDropDown">{{ dropdownItem | translate}}</button>
    </ion-list>
  `
})
export class PopoverPage {
  orderType: OrderType;
  aDropdownItem: string[] = [];

  constructor(public viewCtrl: ViewController, private navParams: NavParams) {
  }

  ngOnInit() {
    console.log("ngOnInit");
    console.log(this);
    console.log(this.navParams);
    console.log(this.navParams.data);
    this.aDropdownItem = this.navParams.get('isProfit')
        ? ["past7daysProfitability", "totalProfitability", "past7daysProfit", "totalProfit"]
        : ["past7daysAccuracy", "totalAccuracy"];
  }

  updateOrderType(idx: number) {
    this.orderType = new OrderType(false, false, false, false, false, false, false);
    if (this.navParams.get('isProfit')) {
      if (idx == 0) {
        this.orderType.isProfitabilityLast7Days = true;
      } else if (idx == 1) {
        this.orderType.isTotalProfitability = true;
      } else if (idx == 2) {
        this.orderType.isProfitLast7Days = true;
      } else if (idx == 3) {
        this.orderType.isTotalProfit = true;
      }
    } else if (this.navParams.get('isAccuracy')) {
      if (idx == 0) {
        this.orderType.isAccuracyOrderLast7Days = true;
      } else if (idx == 1) {
        this.orderType.isTotalAccuracyOrder= true;
      }
    }
    // Close the popover
	  this.close();
  }

  close() {
    this.viewCtrl.dismiss(this.orderType);
  }
}

export class OrderType {
  isTipsScore: boolean;
  isProfitabilityLast7Days: boolean;
  isTotalProfitability: boolean;
  isAccuracyOrderLast7Days: boolean;
  isTotalAccuracyOrder: boolean;
  isProfitLast7Days: boolean;
  isTotalProfit: boolean;

  constructor(isTipsScore: boolean, isProfitabilityLast7Days : boolean, isTotalProfitability : boolean,
      isAccuracyOrderLast7Days : boolean, isTotalAccuracyOrder : boolean,
      isProfitLast7Days: boolean, isTotalProfit: boolean) {
    this.isTipsScore = isTipsScore;
    this.isProfitabilityLast7Days = isProfitabilityLast7Days;
    this.isTotalProfitability = isTotalProfitability;
    this.isAccuracyOrderLast7Days = isAccuracyOrderLast7Days;
    this.isTotalAccuracyOrder = isTotalAccuracyOrder;
    this.isProfitLast7Days = isProfitLast7Days;
    this.isTotalProfit = isTotalProfit;
  }

  setTipsScore() {
    this.reset();
    this.isTipsScore = true;
  }

  setProfit() {
    this.reset();
    this.isTotalProfit = true;
  }

  setAccuracy() {
    this.reset();
    this.isTotalAccuracyOrder = true;
  }

  getTipsScore(): boolean {
    return this.isTipsScore;
  }

  getProfitabilityLast7Days(): boolean {
    return this.isProfitabilityLast7Days;
  }

  getTotalProfitability(): boolean {
    return this.isTotalProfitability;
  }

  getAccuracyOrderLast7Days(): boolean {
    return this.isAccuracyOrderLast7Days;
  }

  getTotalAccuracyOrder(): boolean {
    return this.isTotalAccuracyOrder;
  }

  getProfitLast7Days(): boolean {
    return this.isProfitLast7Days;
  }

  getTotalProfit(): boolean {
    return this.isTotalProfit;
  }

  isProfitOrder(): boolean {
    return this.isProfitabilityLast7Days || this.isTotalProfitability
        || this.isProfitLast7Days || this.isTotalProfit;
  }

  isAccuracyOrder(): boolean {
    return this.isAccuracyOrderLast7Days || this.isTotalAccuracyOrder;
  }

  isEnableOrder(): boolean {
    return this.isProfitabilityLast7Days || this.isTotalProfitability
        || this.isAccuracyOrderLast7Days || this.isTotalAccuracyOrder
        || this.isProfitLast7Days || this.isTotalProfit;
  }

  getOrderNum(): number {
    if (this.isTipsScore) {
      return 0;
    } else if (this.isTotalProfitability) {
      return 1;
    } else if (this.isTotalAccuracyOrder) {
      return 2;
    } else if (this.isProfitabilityLast7Days) {
      return 3;
    } else if (this.isAccuracyOrderLast7Days) {
      return 4;
    } else if (this.isTotalProfit) {
      return 5;
    } else if (this.isProfitLast7Days) {
      return 6;
    }
    return 0;
  }

  reset() {
    this.isTipsScore = false;
    this.isProfitabilityLast7Days = false;
    this.isTotalProfitability = false;
    this.isAccuracyOrderLast7Days = false;
    this.isTotalAccuracyOrder = false;
    this.isProfitLast7Days = false;
    this.isTotalProfit = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/leader-board/popover.ts